(function(){
  if(window.velvetTouchImagePreviewReady) return;
  window.velvetTouchImagePreviewReady = true;

  var activePreview = null;
  var releaseTimer = null;

  function findPreviewMedia(target){
    if(!target || !target.closest) return null;
    var media = target.closest('.product-card__image, .velvet-home-card__media');
    if(!media) return null;
    var hasSecondImage = media.classList.contains('product-card__image')
      ? media.querySelector('.second-image')
      : media.querySelector('.velvet-home-card__image--secondary');
    return hasSecondImage ? media : null;
  }

  function activatePreview(target){
    var media = findPreviewMedia(target);
    if(!media) return;
    if(activePreview && activePreview !== media) activePreview.classList.remove('is-touch-preview');
    window.clearTimeout(releaseTimer);
    activePreview = media;
    activePreview.classList.add('is-touch-preview');
  }

  function releasePreview(){
    window.clearTimeout(releaseTimer);
    releaseTimer = window.setTimeout(function(){
      if(activePreview) activePreview.classList.remove('is-touch-preview');
      activePreview = null;
    }, 650);
  }

  if(window.PointerEvent){
    document.addEventListener('pointerdown', function(event){
      if(event.pointerType === 'mouse') return;
      activatePreview(event.target);
    }, { passive: true });
    document.addEventListener('pointerup', releasePreview, { passive: true });
    document.addEventListener('pointercancel', releasePreview, { passive: true });
  } else {
    document.addEventListener('touchstart', function(event){ activatePreview(event.target); }, { passive: true });
    document.addEventListener('touchend', releasePreview, { passive: true });
    document.addEventListener('touchcancel', releasePreview, { passive: true });
  }
})();
